export const AuditEntityType = {
  Firm: "Firm",
  FirmContact: "Firm Contact",
  DataAdmin: "Data Admin",
  Person: "Professional",
  Office: "Office",
  OfficeContact: "Office Contact",
  OfficeMainContact: "Office Main Contact",
  FirmNote: "Firm Note",
  AreaOfPractice: "Area Of Practice",
  AopRanking: "AOP Ranking",
  PracticeIndustry: "Practice Industry",
  RepresentativeClient: "Representative Client",
  BarAdmission: "Bar Admission",
  Education: "Education",
  Degree: "Degree",
  School: "School",
  Language: "Language",
  Country: "Country",
  Region: "Region",
  State: "State",
  SubState: "Sub State",
  City: "City",
  GlobalCrisis: "Global Crisis",
  Company: "Company",
  Content: "Content",
  ContentTag: "Content Tag",
  ContentGeneralTopic: "Content General Topic",
  Blog: "Blog",
  Council: "Council",
  Bod: "Bod",
  Objectives: "Objectives",
  GuestSpeaker: "GuestSpeaker",
  Event: "Event",
  Registration: "Registration",
  Payment: "Payment",
  Billing: "Billing",
  Fees: "Fees",
  AccountingFees: "Accounting Fees",
  Group: "Group",
  GroupMembership: "Group Membership",
  GroupFile: "GroupFile",
  Forum: "Forum",
  ForumMessage: "Forum Message",
  DealMaker: "Deal Maker",
  EmailTemplate: "Email Template",
  EmailSend: "Email Send",
  EmailCategory: "Email Category",
  EmailAsset: "Email Asset",
  EmailDistributionList: "Email Distribution List",
  EmailUnsubscriber: "Email Unsubscriber",
  Permission: "Permission",
  InvoiceHistory: "InvoiceHistory",
}

export const AuditActionType = {
  CREATE: "Create",
  UPDATE: "Update",
  DELETE: "Delete",
} as const;


export const AccessActionType = {
  LOGIN_SUCCESS: "Login Success",
  LOGIN_FAILED: "Login Failed",
  LOGOUT: "Logout",
  PASSWORD_RESET_REQUEST: "Password Reset Request",
  PASSWORD_RESET_SUCCESS: "Password Reset Success",
  PASSWORD_CHANGE: "Password Change",
  MFA_CHALLENGE: "MFA Challenge",
  MFA_SUCCESS: "MFA Success",
  MFA_FAILED: "MFA Failed",
  MFA_ENABLED: "MFA Enabled",
  MFA_DISABLED: "MFA Disabled",
} as const;

/** AccessLog actions included in firm login quick-filter tabs. */
export const ACCESS_LOGIN_FLOW_ACTIONS = [
  "LOGIN_SUCCESS",
  "LOGIN_FAILED",
  "LOGOUT",
  "MFA_CHALLENGE",
  "MFA_SUCCESS",
  "MFA_FAILED",
  "MFA_ENABLED",
  "MFA_DISABLED",
  "PASSWORD_RESET_REQUEST",
  "PASSWORD_RESET_SUCCESS",
] as const;

export type AuditActionTypeEnum = keyof typeof AuditActionType;
export type AuditEntityTypeEnum = keyof typeof AuditEntityType;
export type AccessActionTypeEnum = keyof typeof AccessActionType;